import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AdminPanel from './pages/admin';
import AdminLogin from './pages/AdminLogin';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Resources from './pages/Resources';
import ProtectedRoute from './components/ProtectedRoute';
import { useEffect, useState } from 'react'; // Add useState
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import BackgroundEffect from './components/BackgroundEffect';
import './styles/global.css';
import AnalyticsDashboard from './components/analytics/AnalyticsDashboard';
import PublicAnalyticsDashboard from './components/analytics/PublicAnalyticsDashboard';

// Create a Theme Context
import React from 'react';
export const ThemeContext = React.createContext<{
  theme: 'light' | 'dark';
  setTheme: (theme: 'light' | 'dark') => void;
}>({
  theme: 'light',
  setTheme: () => {},
});

function App() {
  // Remove this incomplete line
  // const isAdmin = 
  
  // Add theme state here
  const [theme, setTheme] = useState<'light' | 'dark'>('light');
  
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log("Auth state changed:", user ? "User logged in" : "User logged out");
    });
    
    return () => unsubscribe();
  }, []);
  
  // Add theme detection
  useEffect(() => {
    // Check system preference for dark/light mode
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    setTheme(prefersDark ? "dark" : "light");

    // Add listener for theme changes
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e: MediaQueryListEvent) => {
      setTheme(e.matches ? "dark" : "light");
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  // Apply theme to document
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <Router>
        <div className={`app ${theme}`}>
          <BackgroundEffect />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/analytics" element={<PublicAnalyticsDashboard />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminPanel />
                <AnalyticsDashboard />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </ThemeContext.Provider>
  );
}

export default App;